// @flow
import * as ActionTypes from '../../constants/ActionTypes';

export const sellerContactsReset = () => ({
  type: ActionTypes.SELLER_CONTACTS_RESET
});

// Upload contacts file
export const uploadContacts = (formData) => ({
  type: ActionTypes.SELLER_UPLOAD_CONTACTS_START,
  formData: formData,
});

export const uploadContactsSuccess = (data) => {
  return {
    type: ActionTypes.SELLER_UPLOAD_CONTACTS_SUCCESS,
    payload: data,
  };
};

export const uploadContactsFailure = (error) => ({
  type: ActionTypes.SELLER_UPLOAD_CONTACTS_FAILURE,
  payload: error,
});

// Get contacts list
export const getContacts = (params) => ({
  type: ActionTypes.SELLER_GET_CONTACTS_START,
  payload: params,
});

export const getContactsSuccess = (data) => {
  return {
    type: ActionTypes.SELLER_GET_CONTACTS_SUCCESS,
    payload: data,
  };
};

export const getContactsFailure = (error) => ({
  type: ActionTypes.SELLER_GET_CONTACTS_FAILURE,
  payload: error,
});

// Get contact detail
export const getContactDetail = (contactId) => ({
  type: ActionTypes.SELLER_GET_CONTACT_DETAIL_START,
  payload: { contactId },
});

export const getContactDetailSuccess = (data) => {
  return {
    type: ActionTypes.SELLER_GET_CONTACT_DETAIL_SUCCESS,
    payload: data,
  };
};

export const getContactDetailFailure = (error) => ({
  type: ActionTypes.SELLER_GET_CONTACT_DETAIL_FAILURE,
  payload: error,
});

// Create contact
export const createContact = (contactData) => ({
  type: ActionTypes.SELLER_CREATE_CONTACT_START,
  payload: contactData,
});

export const createContactSuccess = (data) => {
  return {
    type: ActionTypes.SELLER_CREATE_CONTACT_SUCCESS,
    payload: data,
  };
};

export const createContactFailure = (error) => ({
  type: ActionTypes.SELLER_CREATE_CONTACT_FAILURE,
  payload: error,
});

// Update contact
export const updateContact = (contactId, contactData) => ({
  type: ActionTypes.SELLER_UPDATE_CONTACT_START,
  payload: { contactId, ...contactData },
});

export const updateContactSuccess = (data) => {
  return {
    type: ActionTypes.SELLER_UPDATE_CONTACT_SUCCESS,
    payload: data,
  };
};

export const updateContactFailure = (error) => ({
  type: ActionTypes.SELLER_UPDATE_CONTACT_FAILURE,
  payload: error,
});

// Delete contact
export const deleteContact = (contactId) => ({
  type: ActionTypes.SELLER_DELETE_CONTACT_START,
  payload: { contactId },
});

export const deleteContactSuccess = (data) => {
  return {
    type: ActionTypes.SELLER_DELETE_CONTACT_SUCCESS,
    payload: data,
  };
};

export const deleteContactFailure = (error) => ({
  type: ActionTypes.SELLER_DELETE_CONTACT_FAILURE,
  payload: error,
});

// Delete multiple contacts
export const deleteMultipleContacts = (contactIds) => ({
  type: ActionTypes.SELLER_DELETE_MULTIPLE_CONTACTS_START,
  payload: { contactIds },
});

export const deleteMultipleContactsSuccess = (data) => {
  return {
    type: ActionTypes.SELLER_DELETE_MULTIPLE_CONTACTS_SUCCESS,
    payload: data,
  };
};

export const deleteMultipleContactsFailure = (error) => ({
  type: ActionTypes.SELLER_DELETE_MULTIPLE_CONTACTS_FAILURE,
  payload: error,
});

// Get contact lists
export const getContactLists = (params) => ({
  type: ActionTypes.SELLER_GET_CONTACT_LISTS_START,
  payload: params,
});

export const getContactListsSuccess = (data) => {
  return {
    type: ActionTypes.SELLER_GET_CONTACT_LISTS_SUCCESS,
    payload: data,
  };
};

export const getContactListsFailure = (error) => ({
  type: ActionTypes.SELLER_GET_CONTACT_LISTS_FAILURE,
  payload: error,
});

// Create contact list
export const createContactList = (listData) => ({
  type: ActionTypes.SELLER_CREATE_CONTACT_LIST_START,
  payload: listData,
});

export const createContactListSuccess = (data) => {
  return {
    type: ActionTypes.SELLER_CREATE_CONTACT_LIST_SUCCESS,
    payload: data,
  };
};

export const createContactListFailure = (error) => ({
  type: ActionTypes.SELLER_CREATE_CONTACT_LIST_FAILURE,
  payload: error,
});

// Get subscriptions
export const getSubscriptions = (params) => ({
  type: ActionTypes.SELLER_GET_SUBSCRIPTIONS_START,
  payload: params,
});

export const getSubscriptionsSuccess = (data) => {
  return {
    type: ActionTypes.SELLER_GET_SUBSCRIPTIONS_SUCCESS,
    payload: data,
  };
};

export const getSubscriptionsFailure = (error) => ({
  type: ActionTypes.SELLER_GET_SUBSCRIPTIONS_FAILURE,
  payload: error,
});

// Send notification to contacts
export const sendNotificationToContacts = (notificationData) => ({
  type: ActionTypes.SELLER_SEND_NOTIFICATION_TO_CONTACTS_START,
  payload: notificationData,
});

export const sendNotificationToContactsSuccess = (data) => {
  return {
    type: ActionTypes.SELLER_SEND_NOTIFICATION_TO_CONTACTS_SUCCESS,
    payload: data,
  };
};

export const sendNotificationToContactsFailure = (error) => ({
  type: ActionTypes.SELLER_SEND_NOTIFICATION_TO_CONTACTS_FAILURE,
  payload: error,
});

// Send notification to contact list
export const sendNotificationToList = (notificationData) => ({
  type: ActionTypes.SELLER_SEND_NOTIFICATION_TO_LIST_START,
  payload: notificationData,
});

export const sendNotificationToListSuccess = (data) => {
  return {
    type: ActionTypes.SELLER_SEND_NOTIFICATION_TO_LIST_SUCCESS,
    payload: data,
  };
};

export const sendNotificationToListFailure = (error) => ({
  type: ActionTypes.SELLER_SEND_NOTIFICATION_TO_LIST_FAILURE,
  payload: error,
});

// Get message templates
export const getMessageTemplates = () => ({
  type: ActionTypes.SELLER_GET_MESSAGE_TEMPLATES_START,
});

export const getMessageTemplatesSuccess = (data) => {
  return {
    type: ActionTypes.SELLER_GET_MESSAGE_TEMPLATES_SUCCESS,
    payload: data,
  };
};

export const getMessageTemplatesFailure = (error) => ({
  type: ActionTypes.SELLER_GET_MESSAGE_TEMPLATES_FAILURE,
  payload: error,
});



